import { TableCell, TableHead, cn } from "@rarible_int/anaconda_ui_components"

interface CellProps {
  children: React.ReactNode
  className?: string
}

export function HeaderCell({ children, className }: CellProps) {
  return (
    <TableHead
      className={cn(
        "text-right",
        "first:sticky first:left-0 first:text-left",
        className,
      )}
    >
      {children}
    </TableHead>
  )
}

export function Cell({ children, className }: CellProps) {
  return (
    <TableCell
      className={cn(
        "text-right",
        "first:sticky first:left-0 first:p-2 first:text-left",
        className,
      )}
    >
      {children}
    </TableCell>
  )
}
